import { Form, Input, Select, Button } from 'antd';
import type { FormInstance } from 'antd';
import { BRAND, SEGMENTS, Segment } from '../constants';
import { getRegion } from '../../../../components/regionWrapper';
import { Region } from '../../../../utils/commonInterfaces';

const { Option } = Select;

interface FiltersBarProps {
    form: FormInstance;
    activeSegment: string;
    statuses: any[];
    canResetFilter: boolean;
    onSearch: (values: any) => void;
    onSegmentChange: (segment: Segment) => void;
    onStatusChange: (statusId: any) => void;
    onClearFilter: () => void;
}

// Filter row — segment tabs + combined search + status dropdown + Search/Clear.
export default function FiltersBar({
    form, activeSegment, statuses, canResetFilter,
    onSearch, onSegmentChange, onStatusChange, onClearFilter,
}: FiltersBarProps) {
    const region = getRegion();
    return (
        <Form name="basic" autoComplete="off" form={form} onFinish={onSearch}>
            <div style={{
                display: 'flex', alignItems: 'center', gap: 10, flexWrap: 'wrap', marginBottom: 14,
            }}>
                <div className="insight-segments" style={{
                    display: 'inline-flex', gap: 4, padding: 3,
                    background: '#F1F5F5', borderRadius: 10, border: '1px solid #E3EAEA',
                    opacity: !statuses.length ? 0.5 : 1,
                    cursor: !statuses.length ? 'not-allowed' : 'pointer',
                }}>
                    {SEGMENTS.map((seg) => {
                        const active = activeSegment === seg.key;
                        return (
                            <button
                                key={seg.key}
                                type="button"
                                onClick={() => onSegmentChange(seg)}
                                style={{
                                    border: 'none',
                                    cursor: !statuses.length ? 'not-allowed' : 'pointer',
                                    padding: '5px 14px',
                                    borderRadius: 8,
                                    fontSize: 12,
                                    fontWeight: 600,
                                    transition: 'all 0.2s ease',
                                    background: active ? BRAND.teal : 'transparent',
                                    color: active ? '#fff' : '#5b6b70',
                                    boxShadow: active ? '0 3px 10px rgba(13, 82, 87, 0.30)' : 'none',
                                }}
                                disabled={!statuses.length}
                            >
                                {seg.label}
                            </button>
                        );
                    })}
                </div>
                <Form.Item name="search" style={{ marginBottom: 0, flex: 1, minWidth: 200 }}>
                    <Input allowClear size="small" placeholder={`Filter by Staff ID, ${region === Region.EG ? 'Bank Account Number, ' : 'Iqama / '}National ID or Phone Number`} />
                </Form.Item>
                <Form.Item name="status" style={{ marginBottom: 0, minWidth: 150 }}>
                    <Select allowClear size="small" placeholder="Status: Any" onChange={onStatusChange} disabled={!statuses.length}>
                        {statuses.map((status: any, key: number) => (
                            <Option value={status.id} status={status} key={key}>{status.name}</Option>
                        ))}
                    </Select>
                </Form.Item>
                <Button
                    type="primary"
                    htmlType="submit"
                    size="small"
                    className="np-primary-btn"
                    style={{ minWidth: 96, height: 32, border: 'none', borderRadius: '8px', fontWeight: 600, transition: '0.3s' }}
                >
                    Search
                </Button>
                {canResetFilter && (
                    <Button size="small" style={{ height: 32, borderRadius: '8px' }} onClick={onClearFilter} danger>
                        Clear filter
                    </Button>
                )}
            </div>
        </Form>
    );
}
